import React, { Component } from 'react';

import { Box } from '@mui/material';

import BookingCancelledToggle from './BookingCancelledToggle';
import SurchargeToggle from './SurchargeToggle';
import type { SurchargeInfo } from './SurchargeToggle';
import TourCancellationWarning from './TourCancellationWarning';

interface FullRefund {
  variant_of_refund?: string;
  has_surcharge?: boolean;
  is_refunded_surcharge?: boolean | null;
  is_tour?: boolean;
  is_tour_with_active_optional_extras?: boolean;
  is_subscription?: boolean;
  mark_cancelled?: boolean | null;
}

interface Props {
  handleFlagChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleTmpChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  tmpValue: (key: 'fee') => string | number;
  refund: FullRefund;
  surchargeInfo: SurchargeInfo;
  with_fee?: boolean;
  isActive?: boolean;
  isPaymentScheduleServiceFee?: boolean;
}

export default class FullRefundVariant extends Component<Props> {
  render() {
    const {
      handleFlagChange,
      handleTmpChange,
      isPaymentScheduleServiceFee,
      refund,
      surchargeInfo,
      tmpValue,
      with_fee,
    } = this.props;
    const shouldDisallowTourCancellation = refund.is_tour && refund.is_tour_with_active_optional_extras;

    return (
      <Box id="FullRefundVariant">
        {with_fee && (
          <Box id="fee">
            <label>Fee Charged to Customer:</label>
            <input
              name="fee"
              value={tmpValue('fee')}
              onChange={handleTmpChange}
              className="data-hj-whitelist"
              data-cy="Fee Charged to Customer"
            />
          </Box>
        )}
        {refund.has_surcharge && (
          <SurchargeToggle
            handleFlagChange={handleFlagChange}
            surchargeInfo={surchargeInfo}
            is_refunded_surcharge={refund.is_refunded_surcharge}
          />
        )}
        <TourCancellationWarning shouldDisallowTourCancellation={shouldDisallowTourCancellation} />
        {!shouldDisallowTourCancellation && !refund.is_subscription && !isPaymentScheduleServiceFee && (
          <BookingCancelledToggle handleFlagChange={handleFlagChange} mark_cancelled={refund.mark_cancelled} />
        )}
      </Box>
    );
  }
}
